import { Bike, Store } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Field } from "@/components/common";
import { brl } from "@/lib/api";
import { shipInfo } from "@/lib/shop";
import { CustomerAddress } from "@/components/delivery/CustomerAddress";

function ZoneAddress({ st, ship, setShip }) {
  const zones = st.delivery_zones || [];
  const a = ship.addr || {};
  const setA = (k) => (e) => setShip((s) => ({ ...s, addr: { ...s.addr, [k]: e.target.value } }));
  return (
    <div className="grid grid-cols-3 gap-2" data-testid="shop-zone-address">
      {zones.length > 0 ? (
        <Field label="Bairro" className="col-span-3">
          <select value={ship.zone} onChange={(e) => setShip((s) => ({ ...s, zone: e.target.value, addr: { ...s.addr, district: e.target.value } }))} className="h-10 rounded-md border bg-white px-2 text-sm" data-testid="shop-zone-select">
            <option value="">Selecione o seu bairro</option>
            {zones.map((z) => <option key={z.name} value={z.name}>{z.name} · {brl(z.fee)}</option>)}
          </select>
        </Field>
      ) : <Field label="Bairro" className="col-span-3"><Input value={a.district || ""} onChange={setA("district")} className="bg-white" data-testid="shop-addr-district" /></Field>}
      <Field label="Rua" className="col-span-2"><Input value={a.street || ""} onChange={setA("street")} className="bg-white" data-testid="shop-addr-street" /></Field>
      <Field label="Número"><Input value={a.number || ""} onChange={setA("number")} className="bg-white" data-testid="shop-addr-number" /></Field>
      <Field label="Complemento / referência" className="col-span-3"><Input value={a.complement || ""} onChange={setA("complement")} className="bg-white" data-testid="shop-addr-complement" /></Field>
    </div>
  );
}

function ShipResult({ st, ship }) {
  const info = shipInfo(st, ship);
  if (ship.type === "retirada") return <p className="rounded-lg bg-slate-100 p-3 text-sm" data-testid="shop-ship-result">Retire em: <b>{st.address || st.name}</b> · pronto em ~{info.eta} min</p>;
  if (!info.ready) return null;
  return <p className="rounded-lg bg-emerald-50 p-3 text-sm text-emerald-800" data-testid="shop-ship-result">Taxa de entrega <b>{info.fee ? brl(info.fee) : "grátis"}</b> · tempo estimado <b>~{info.eta} min</b>{st.min_order > 0 ? ` · pedido mínimo ${brl(st.min_order)}` : ""}</p>;
}

export function ShipForm({ st, slug, ship, setShip, color }) {
  const types = [["delivery", "Entrega", "A gente leva até você", Bike], ["retirada", "Retirada", "Você retira no local", Store]].filter(([k]) => k !== "delivery" || st.delivery_enabled);
  return (
    <div className="space-y-4" data-testid="shop-ship-form">
      <p className="font-semibold">Como você quer receber o pedido?</p>
      <div className="grid grid-cols-2 gap-2">{types.map(([k, l, d, Icon]) => (
        <button key={k} type="button" onClick={() => setShip((s) => ({ ...s, type: k }))} className="flex items-center gap-3 rounded-xl border p-3 text-left transition-colors" style={ship.type === k ? { borderColor: color, background: `${color}14` } : {}} data-testid={`shop-type-${k}`}>
          <Icon className="h-6 w-6 shrink-0" style={{ color }} /><span><span className="block text-sm font-semibold">{l}</span><span className="text-xs text-slate-500">{d}</span></span>
        </button>
      ))}</div>
      {ship.type === "delivery" && (st.delivery_area_mode === "mapa"
        ? <CustomerAddress slug={slug} st={st} value={{ addr: ship.addr, point: ship.point, quote: ship.quote }} onChange={(v) => setShip((s) => ({ ...s, ...v }))} inputCls="bg-white" lazyMap />
        : <ZoneAddress st={st} ship={ship} setShip={setShip} />)}
      <ShipResult st={st} ship={ship} />
    </div>
  );
}
